import axios from 'axios'

const BASEURLZAIFORMDATA = axios.create({
    baseURL: process.env.REACT_APP_API_ZAI,
    headers: {
        'Content-Type': 'multipart/form-data',
        'idorganizacao': process.env.REACT_APP_ORGANIZACAO_HG
    }
})

export default BASEURLZAIFORMDATA